// extracted by mini-css-extract-plugin
module.exports = {"permissionsProduct":"AccessPermissionsTables_permissionsProduct__3wlCH"};